<div class="wrapper">
  <div class="title">
    {{'search.autocompletion.title' | translate | uppercase}}
  </div>
  <div class="autocomplete-results">
    @if (autoCompleteResult) {
      @for (suggestion of autoCompleteResult.suggestions; track suggestion) {
        <button class="autocompletion-button" (mousedown)="selectAutocompletion(suggestion)">
          @if (suggestion.type == AutocompletionType.Song) {
            <tun-autocomplete-song-icon-v5  class="icon icon-scaled-svg-button icon-autocomplete-button"></tun-autocomplete-song-icon-v5>
          }
          @if (suggestion.type == AutocompletionType.Artist) {
            <tun-autocomplete-artist-icon-v5  class="icon icon-scaled-svg-button icon-autocomplete-button"></tun-autocomplete-artist-icon-v5>
          }
          {{suggestion.autocompletionText}}
        </button>
      }
    }
  </div>

</div>
